/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Commit } from "./Commit";
export const ListCommitsResponse = core.serialization.object({
    data: core.serialization.list(Commit),
});
